import FlightDetailsList from './FlightDetailsList'

export default FlightDetailsList
